"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InfiniteList = _interopRequireDefault(require("../../../InfiniteList"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _constants = require("../../../../constants");
var _ClientSearchCard = _interopRequireDefault(require("../../Clients/ClientSearchCard"));
var _OrderSearchCard = _interopRequireDefault(require("../../Orders/OrderSearchCard"));
var _CommunicationSearchCard = _interopRequireDefault(require("../../Logs/CommunicationSearchCard"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _excluded = ["total", "type", "open", "hasNextPage", "displayCount", "minimumBatchSize", "threshold", "items", "action", "isLoading"],
  _excluded2 = ["onToggle", "onLoadRequest", "onCardClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ITEM_HEIGHT = 44;
var PAGE_SIZE_DEFAULT = 20;
var THRESHOLD_DEFAULT = 5;
var getItemKey = function getItemKey(index, data) {
  return (0, _get2["default"])(data, "".concat(index, ".id")) || index;
};
var TITLE_COMPONENT = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
  None: ''
}, _constants.SEARCH_CARD_TYPES.CLIENTS, 'клиенты'), _constants.SEARCH_CARD_TYPES.ORDERS, 'заказы'), _constants.SEARCH_CARD_TYPES.COMMUNICATION, 'коммуникации'), _constants.SEARCH_CARD_TYPES.MESSAGES, 'сообщения');
var ListSearchCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var total = _ref.total,
    type = _ref.type,
    open = _ref.open,
    hasNextPage = _ref.hasNextPage,
    displayCount = _ref.displayCount,
    minimumBatchSize = _ref.minimumBatchSize,
    threshold = _ref.threshold,
    items = _ref.items,
    action = _ref.action,
    isLoading = _ref.isLoading,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var onToggle = action.onToggle,
    onLoadRequest = action.onLoadRequest,
    onCardClick = action.onCardClick,
    otherAction = (0, _objectWithoutProperties2["default"])(action, _excluded2);
  if (!type) {
    return null;
  }
  var handleToggle = function handleToggle() {
    return onToggle(type);
  };
  var isItemLoaded = function isItemLoaded(index) {
    return !hasNextPage || index < items.length;
  };
  var itemCount = hasNextPage ? items.length + 1 : items.length;
  var handleLoadPage = function handleLoadPage(startIndex, stopIndex) {
    if (isLoading) {
      return;
    }
    onLoadRequest(startIndex, stopIndex);
  };
  var handleCardClick = (0, _react.useCallback)(function (_ref2) {
    var type = _ref2.type,
      item = _ref2.item;
    onCardClick({
      type: type,
      item: item
    });
  });
  var count = Math.min(total, displayCount, items.length);
  var buttonTitle = '';
  var Component;
  var list = items;
  if (!open && count !== items.length) {
    list = items.slice(0, count);
  }
  if (count !== items.length) {
    buttonTitle = open ? 'Свернуть' : 'Показать все';
  }
  switch (type) {
    case _constants.SEARCH_CARD_TYPES.CLIENTS:
      Component = StyledClientsSearchCard;
      break;
    case _constants.SEARCH_CARD_TYPES.ORDERS:
      Component = StyledOrderSearchCard;
      break;
    case _constants.SEARCH_CARD_TYPES.COMMUNICATION:
    case _constants.SEARCH_CARD_TYPES.MESSAGES:
      Component = StyledCommunicationSearchCard;
      break;
    default:
      Component = null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledListSearchCard, props, /*#__PURE__*/_react["default"].createElement(StyledTitelHeader, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, TITLE_COMPONENT[type], /*#__PURE__*/_react["default"].createElement("span", null, " \u2022 "), total), total > 0 && buttonTitle && /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: handleToggle
  }, buttonTitle)), /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    open: open
  }, !open && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isLoading ? list.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, item, {
      disabled: item.disabled,
      key: item.id,
      onClick: function onClick() {
        return handleCardClick({
          type: type,
          item: item
        });
      }
    }, otherAction));
  }) : /*#__PURE__*/_react["default"].createElement(StyledThrobberContainer, null, /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
    color: "#007aff"
  }))), open && /*#__PURE__*/_react["default"].createElement(_InfiniteList["default"], (0, _extends2["default"])({}, props, {
    itemData: list,
    itemKey: getItemKey,
    itemSize: ITEM_HEIGHT,
    isItemLoaded: isItemLoaded,
    itemCount: itemCount,
    minimumBatchSize: minimumBatchSize,
    onLoadRequest: handleLoadPage,
    threshold: threshold
  }), function (_ref3) {
    var data = _ref3.data,
      index = _ref3.index,
      style = _ref3.style;
    if (!isItemLoaded(index)) {
      return /*#__PURE__*/_react["default"].createElement(StyledLoadingCommunication, {
        style: style
      }, ' ', "Loading...");
    }
    var item = (0, _get2["default"])(data, "".concat(index));
    if (!item) {
      return null;
    }
    var newStyle = index ? style : _objectSpread({}, style);
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      style: _objectSpread(_objectSpread({}, newStyle), {}, {
        height: ITEM_HEIGHT
      })
    }, item, otherAction, {
      onClick: function onClick() {
        return handleCardClick({
          type: type,
          item: item
        });
      }
    }));
  })));
});
ListSearchCard.propTypes = {
  className: _propTypes["default"].string,
  displayCount: _propTypes["default"].number,
  minimumBatchSize: _propTypes["default"].number,
  threshold: _propTypes["default"].number,
  total: _propTypes["default"].number.isRequired,
  type: _propTypes["default"].oneOf(Object.values(_constants.SEARCH_CARD_TYPES)).isRequired,
  open: _propTypes["default"].bool,
  hasNextPage: _propTypes["default"].bool,
  items: _propTypes["default"].arrayOf(_propTypes["default"].object),
  action: _propTypes["default"].shape({
    onToggle: _propTypes["default"].func,
    onLoadRequest: _propTypes["default"].func,
    onCallClick: _propTypes["default"].func,
    onEmailClick: _propTypes["default"].func,
    onCreateTicket: _propTypes["default"].func,
    onCardClick: _propTypes["default"].func
  }),
  isLoading: _propTypes["default"].bool
};
ListSearchCard.defaultProps = {
  className: '',
  displayCount: 3,
  minimumBatchSize: PAGE_SIZE_DEFAULT,
  threshold: THRESHOLD_DEFAULT,
  items: [],
  open: false,
  hasNextPage: false,
  action: Function.prototype,
  isLoading: false
};
var StyledListSearchCard = _styledComponents["default"].div.withConfig({
  displayName: "ListSearchCard__StyledListSearchCard",
  componentId: "sc-11340d3-0"
})(["background-color:#fff;height:100%;width:100%;position:relative;"]);
var StyledTitelHeader = _styledComponents["default"].div.withConfig({
  displayName: "ListSearchCard__StyledTitelHeader",
  componentId: "sc-11340d3-1"
})(["width:100%;font-size:14px;line-height:18px;height:40px;color:#17181a;display:flex;padding-left:20px;padding-right:11px;padding-top:16px;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "ListSearchCard__StyledTitle",
  componentId: "sc-11340d3-2"
})(["font-weight:bold;letter-spacing:1.9px;text-transform:uppercase;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ListSearchCard__StyledButton",
  componentId: "sc-11340d3-3"
})(["width:90px;height:18px;font-size:14px;padding:0px;margin-left:7px;line-height:1.29;letter-spacing:0.1px;border:none;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "ListSearchCard__StyledContainer",
  componentId: "sc-11340d3-4"
})(["display:flex;flex-direction:column;flex-grow:1;width:100%;height:100%;", " ", ""], function (props) {
  return props.open && "\n    height: 264px;\n  ";
}, function (props) {
  return !props.open && "\n    padding-bottom: 25px;\n  ";
});
var StyledClientsSearchCard = (0, _styledComponents["default"])(_ClientSearchCard["default"]).withConfig({
  displayName: "ListSearchCard__StyledClientsSearchCard",
  componentId: "sc-11340d3-5"
})(["padding:13px 20px;border-top:1px solid #e9ebee;cursor:pointer;", " :hover{background-color:#dcedff;}"], function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && "\n    opacity: 0.5;\n    cursor: not-allowed;\n  ";
});
var StyledOrderSearchCard = (0, _styledComponents["default"])(_OrderSearchCard["default"]).withConfig({
  displayName: "ListSearchCard__StyledOrderSearchCard",
  componentId: "sc-11340d3-6"
})(["padding:0 20px;border-top:1px solid #e9ebee;cursor:pointer;", " :hover{background-color:#dcedff;}"], function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && "\n    opacity: 0.5;\n    cursor: not-allowed;\n  ";
});
var StyledCommunicationSearchCard = (0, _styledComponents["default"])(_CommunicationSearchCard["default"]).withConfig({
  displayName: "ListSearchCard__StyledCommunicationSearchCard",
  componentId: "sc-11340d3-7"
})(["padding:0 20px;border-top:1px solid #e9ebee;cursor:pointer;", " :hover{background-color:#dcedff;}"], function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && "\n    opacity: 0.5;\n    cursor: not-allowed;\n  ";
});
var StyledLoadingCommunication = _styledComponents["default"].div.withConfig({
  displayName: "ListSearchCard__StyledLoadingCommunication",
  componentId: "sc-11340d3-8"
})(["align-items:center;height:", "px;display:flex;justify-content:center;width:100%;"], ITEM_HEIGHT);
var StyledThrobberContainer = _styledComponents["default"].div.withConfig({
  displayName: "ListSearchCard__StyledThrobberContainer",
  componentId: "sc-11340d3-9"
})(["margin-top:15px;height:110px;"]);
ListSearchCard.StyledContainer = StyledContainer;
ListSearchCard.SEARCH_CARD_TYPES = _constants.SEARCH_CARD_TYPES;
var _default = exports["default"] = ListSearchCard;